import React, {useState, useRef, useEffect} from 'react'
import { formatDate } from '@fullcalendar/core'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import TextField from '@mui/material/TextField';
// import { INITIAL_EVENTS, createEventId } from './event-utils'

// import EventContent from '../components/Calendar/Event'

import "../css/calendar.scss"

import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Header } from './common'

import FormDialog from '../utils/utilities/Dialog'

const Container = styled.div``

const Main = styled.div`

`
const EventForm = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 0;
  padding-bottom: 1rem;
`;

const CalendarFull = () => {
  const [newEvent, setNewEvent] = useState(null)
  const [scheduledEvents, setScheduledEvents] = useState([
    // {
    //   title: 'All Day Event',
    //   start: new Date().toISOString().slice(0, 10),
    // },
    // {
    //   title: 'Conference',
    //   start: new Date(),
    //   end: new Date(),
    //   backgroundColor: 'red',
    // },
    // {
    //   title: 'Click for Google',
    //   url: 'http://google.com/',
    //   start: new Date().toISOString().slice(0, 10),
    //   allDay: true
    // }
  ])
  const [openDialog, setOpenDialog] = useState(false)
  const [title, setTitle] = useState('')
  const calendarRef = useRef(null)
  let eventGuid = 0

  const createEventId = () => {
    return String(eventGuid++)
  }

 const saveNewEvent = (tt) => {
  let event = newEvent
  if (!event) return
  let calendarApi = event.view.calendar

  calendarApi.unselect() // clear date selection

  if (tt) {
    let newEvent = {
      id: createEventId(),
      title: tt,
      start: event.start,
      end: event.endStr,
      allDay: false,
      classNames: ['manual-scheduled-event'],
      eventType: "manual"
    }
    setScheduledEvents(prevEvents => [...prevEvents, newEvent])
  }
  setOpenDialog(false)
  }

  const handleDateSelect = (event) => {
    console.log(event, "new event")
    setOpenDialog(true)
    setNewEvent(event)
  }

  const handleEventClick = (clickInfo) => {
    let cApi = calendarRef.current.getApi()
    let source = cApi.getEventSourceById('hebcal') // get source by id
    // check if the event clicked is from the source
    console.log(clickInfo.event._def)
    if (clickInfo.event._def.sourceId === source.internalEventSource.sourceId) {
      return
    }
    if (window.confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
      clickInfo.event.remove()
    }
  }


  // useEffect(() => {
  //   cApi = calendarRef.current.getApi()
  //   // let events = cApi.getEventById('hebcal')
  //   // console.log(cApi.currentData, "events")
  // }, [])

 return (
  <Container>
    <FormDialog title="Add Event" forceOpen={openDialog} forceClose={() => setOpenDialog(false)} text="Please enter a new title for your event" saveText="Add Event" saveFunc={() => saveNewEvent(title)}>
      <EventForm>
        <TextField name="title" onChange={(e) => setTitle(e.target.value)} label="Title" size="small" />
      </EventForm>
    </FormDialog>
    <Header><h2>Calendar</h2></Header>

    <Main>
    <FullCalendar
      ref={calendarRef}
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
      headerToolbar={{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      }}
      initialView='dayGridMonth'
      eventSources={[
        {
          id: 'hebcal',
          url: "https://www.hebcal.com/hebcal?cfg=fc&v=1&i=off&maj=on&min=on&nx=on&mf=on&ss=on&lg=he-x-NoNikud&s=on&c=on&geonameid=5128581&d=on&b=15&m=72&",
          method: 'GET',
          extraParams: {
            cachebuster: new Date().valueOf()
          },
          failure: function() {
            alert('there was an error while fetching events!');
          },
          editable: false,
        },
        {
          id: 'manual',
          events: scheduledEvents,
        }
      ]}
      editable={true}
      selectable={true}
      selectMirror={true}
      dayMaxEvents={true}
      select={handleDateSelect}
      eventClick={handleEventClick}
      // eventContent={EventContent}
      // eventDidMount={(info) => {console.log(info.el)}}
      />
      {console.log(calendarRef.current)}
    </Main>
  </Container>
 )
}

export default CalendarFull;